export default __webpack_public_path__ + "static/media/promo.ec84af64.svg";